<template>
	<div class="about">
		<h1>About section</h1>
	</div>
</template>

<script>
export default {
	name: 'about',
	data () {
		return {
			glitter: 'test'
		}
	},
	methods: {
		onSectionLeave (el, done) {
			this.$bus.$emit('transitioner:show', done)
		}
	}
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/sections/About.vue